import { render, staticRenderFns } from "./global-trigger.vue?vue&type=template&id=73528bf7&"
import script from "./global-trigger.vue?vue&type=script&lang=js&"
export * from "./global-trigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports